import { render } from "./TheLabelRequired.vue?vue&type=template&id=42cc3a5e"
import script from "./TheLabelRequired.vue?vue&type=script&lang=js"
export * from "./TheLabelRequired.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Softwaresul\\Projetos\\LWP\\Nil Recruiter\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__